import { ExternalLink } from 'shared/components/ExternalLink/ExternalLink'

// TODO: @core-onboarding-visibility-flag Update this to the new URL when it's available
// const ONBOARDING_WEBINAR_URL = 'https://go.cloudtrucks.com/OnboardingWebinarRegistration.html'
const ONBOARDING_WEBINAR_PLACEHOLDER_URL = 'https://calendly.com/onboarding-team-22/onboarding-call'

export function OnboardingCallButton() {
  return <ExternalLink href={ONBOARDING_WEBINAR_PLACEHOLDER_URL}>Schedule</ExternalLink>
}
